import { showNotify } from 'vant';

// 校验
export function handleParamsDisease (obj) {
  // 上传凭证
  obj.certificateUrl = this.foreachArray(this.uploadGroup, 'uploadValue', (item) => {
    if (item.uploadValue.indexOf('blob') !== -1) {
      return false
    } else {
      return item.uploadValue
    }
  })
  // 过敏史
  if (this.diseaseHistory.allergy.value === 'yes') {
    obj.historyOfAllergy = 1
    obj.allergyDetail = this.sunmarySelect(this.diseaseHistoryList)
    if (this.diseaseHistory.allergy.supplement !== '') {
      obj.allergyDetail += obj.allergyDetail === '' ? this.diseaseHistory.allergy.supplement : (',' + this.diseaseHistory.allergy.supplement)
    }
    obj.allergyDetail = obj.allergyDetail.replaceAll(' ', '')
    if (obj.allergyDetail === '') {
      this.verificationResult = false
      showNotify({
        type: 'warning',
        message: '请输入过敏史',
        duration: 1000
      });
      return false
    }
  }
  // 过往病逝
  if (this.diseaseHistory.historyMedical.value === 'yes') {
    obj.historyOfSickness = 1
    obj.sicknessDetail = this.diseaseHistory.historyMedical.supplement
    obj.sicknessDetail = obj.sicknessDetail.replaceAll(' ', '')
    if (obj.sicknessDetail === '') {
      this.verificationResult = false
      showNotify({
        type: 'warning',
        message: '请输入过往病史',
        duration: 1000
      });
      return false
    }
  }
  // 备孕
  if (this.diseaseHistory.pregnancy.value === 'yes') {
    let temp = this.sunmarySelect(this.pregnancyList)
    switch (temp) {
      case '妊娠':
        obj.pregnancy = 2;
        break;
      case '哺乳':
        obj.pregnancy = 3;
        break;
      case '备孕':
        obj.pregnancy = 1;
        break;
      default:
        this.verificationResult = false
        showNotify({
          type: 'warning',
          message: '请选择妊娠哺乳备孕',
          duration: 1000
        });
        return false
    }
  }
  // 肝功能
  if (this.diseaseHistory.liver === 'yes') {
    obj.liver = 1
  }
  // 肾功能
  if (this.diseaseHistory.renal === 'yes') {
    obj.renal = 1
  }
  // 选择已确诊疾病
  if (this.isHaoYaoShiClient ? (this.bizType === 2 || (this.bizType !== 0 && this.isReviewInquiry === 1)) : this.inquiryMode === 0) {
    obj.illDesc = this.sunmarySelect(this.selectList)
    if (obj.illDesc === '') {
      showNotify({
        type: 'warning',
        message: '请选择已确诊疾病',
        duration: 1000
      })
      this.verificationResult = false
      return false
    }
  }

  // 姓名
  if (obj.patientName === '') {
    showNotify({
      type: 'warning',
      message: '请输入姓名',
      duration: 1000
    })
    this.verificationResult = false
    return false
  }
  // 设身份证
  if (obj.patientIdNo === '') {
    showNotify({
      type: 'warning',
      message: '请输入身份证',
      duration: 1000
    })
    this.verificationResult = false
    return false
  }
  // 联系方式
  if (obj.patientPhone === '') {
    showNotify({
      type: 'warning',
      message: '请输入联系方式',
      duration: 1000
    })
    this.verificationResult = false
    return false
  }
  let reg = /^1[3456789]\d{9}$/
  if (!reg.test(obj.patientPhone)) {
    showNotify({
      type: 'warning',
      message: '手机号码输入不正确',
      duration: 1000
    })
    this.verificationResult = false
    return false;
  }
  // 性别
  obj.patientSex = this.patientInfo.sex === '男' ? 1 : 2
  // 体重
  if (this.patientInfo.age.split('岁')[0] < 14 && this.verificationUniqueID === 0) {
    if (obj.patientWeight === '') {
      showNotify({
        type: 'warning',
        message: '请填写体重',
        duration: 1000
      })
      this.verificationResult = false
      return false
    } else if (obj.patientWeight < 0.1) {
      showNotify({
        type: 'warning',
        message: '体重格式不正确',
        duration: 1000
      })
      this.verificationResult = false
      return false;
    } else if (obj.patientWeight > 99.9) {
      showNotify({
        type: 'warning',
        message: '体重格式不正确',
        duration: 1000
      })
      this.verificationResult = false
      return false;
    } else if (obj.patientWeight.split('.')[1]) {
      if (obj.patientWeight.split('.')[1].length === 0 || obj.patientWeight.split('.')[1].length > 1) {
        showNotify({
          type: 'warning',
          message: '体重格式不正确',
          duration: 1000
        })
        this.verificationResult = false
        return false;
      }
    }
  }
  obj.patientWeight = obj.patientWeight !== '' ? parseFloat(obj.patientWeight) : ''
  // 年龄
  if (parseInt(this.patientInfo.age.split('岁')[0]) === 0 && this.verificationUniqueID === 0) {
    showNotify({
      type: 'warning',
      message: '请填写年龄',
      duration: 1000
    })
    this.verificationResult = false
    return false
  }
  obj.patientAge = parseInt(this.patientInfo.age.split('岁')[0]) !== 0 ? parseInt(this.patientInfo.age.split('岁')[0]) : 0
  // 精神病药品
  if (this.userInfo.sectionCode === '15' && obj.certificateUrl === '') {
    showNotify({
      type: 'warning',
      message: '请上传复诊凭证',
      duration: 1000
    })
    this.verificationResult = false
    return false
  }
}

// 疾病史校验
export function diseaseHistoryChecked () {
  let obj = {}
  // 过敏史
  if (this.diseaseHistory.allergy.value === 'yes') {
    obj.historyOfAllergy = 1
    obj.allergyDetail = this.sunmarySelect(this.diseaseHistoryList)
    if (this.diseaseHistory.allergy.supplement !== '') {
      obj.allergyDetail += obj.allergyDetail === '' ? this.diseaseHistory.allergy.supplement : (',' + this.diseaseHistory.allergy.supplement)
    }
    obj.allergyDetail = obj.allergyDetail.replaceAll(' ', '')
    if (obj.allergyDetail === '') {
      showNotify({
        type: 'warning',
        message: '请输入过敏史',
        duration: 1000
      });
      return false
    }
  }
  // 过往病逝
  if (this.diseaseHistory.historyMedical.value === 'yes') {
    obj.historyOfSickness = 1
    obj.sicknessDetail = this.diseaseHistory.historyMedical.supplement
    obj.sicknessDetail = obj.sicknessDetail.replaceAll(' ', '')
    if (obj.sicknessDetail === '') {
      showNotify({
        type: 'warning',
        message: '请输入过往病史',
        duration: 1000
      });
      return false
    }
  }
  // 备孕
  if (this.diseaseHistory.pregnancy.value === 'yes') {
    let temp = this.sunmarySelect(this.pregnancyList)
    switch (temp) {
      case '妊娠':
        obj.pregnancy = 2;
        break;
      case '哺乳':
        obj.pregnancy = 3;
        break;
      case '备孕':
        obj.pregnancy = 1;
        break;
      default:
        showNotify({
          type: 'warning',
          message: '请选择妊娠哺乳备孕',
          duration: 1000
        });
        return false
    }
  }
  // 肝功能
  if (this.diseaseHistory.liver === 'yes') {
    obj.liver = 1
  }
  // 肾功能
  if (this.diseaseHistory.renal === 'yes') {
    obj.renal = 1
  }
  return true
}

export function checkDisease () {
  let hasDisease = 'no';
  // 过敏史校验
  if (this.diseaseHistory.allergy.value === 'yes') {
    hasDisease = 'yes';
  }
  // 过敏史校验
  if (this.diseaseHistory.historyMedical.value === 'yes') {
    hasDisease = 'yes';
  }
  // 过敏史校验
  if (this.diseaseHistory.pregnancy.value === 'yes') {
    hasDisease = 'yes';
  }
  // 过敏史校验
  if (this.diseaseHistory.liver === 'yes') {
    hasDisease = 'yes';
  }
  // 过敏史校验
  if (this.diseaseHistory.renal === 'yes') {
    hasDisease = 'yes';
  }
  this.pramas.radio = hasDisease;
}
